<template lang="html">

  <section class="wrapper mis-candidaturas-view">

    <div class="container">

      <div class="practicas-formalizadas">

        <nav class="breadcrumb">
          <router-link :to="$t('enlaces.home')">Inicio</router-link>
          <router-link :to="$t('enlaces.miscandidaturas')">Mis candidaturas</router-link>
        </nav>

        <h2>Prácticas formalizadas</h2>


        <template v-if="documentacion.length > 0">
          <p>Estos son los documentos formalizados (anexos a un Convenio de Colaboración Educativa) para la realización
            de tus prácticas como estudiante.</p>
          <div class="contenedor-practicas-formalizadas">
            <practicaformalizada :key="key" :data="el" v-for="(el,key) in documentacion"></practicaformalizada>
          </div>
        </template>

        <template v-if="documentacion.length == 0">
          <p>Aún no tienes ninguna práctica formalizada.</p>
          
        </template>

      </div>


      <template v-if="!!candidaturas">

        <div class="candidaturas" v-if="candidaturas.length != 0">

          <header class="titulos row-start">
            <h3>Candidaturas</h3>
            <h3 class="row-start" @click="showinfo = true">
              Estado
              <a class="show-info"></a>
            </h3>
          </header>

          <div class="contenedor-practicas-formalizadas">
            <candidaturas @erase="eraseCandidatura" v-for="(candidatura,key) in candidaturas" :data="candidatura"
              :key="key"></candidaturas>

          </div>

        </div>

      </template>

      <div class="candidaturas" v-if="!!!candidaturas || candidaturas.length == 0">
        <header class="titulos row-start">
          <h3>Candidaturas</h3>
        </header>
        <p>Aún no tienes candidaturas</p>
      </div>

    </div>


    <div class="cover-popup row-center" v-if="showinfo">
      <div class="popup -estados">
        <a class="close" @click="showinfo = false">✕</a>
        <article class="row-start">
          <h3 class="inscrito">
            Inscrito
          </h3>
          <p>Te has inscrito correctamente en la oferta.</p>
        </article>
        <article class="row-start">
          <h3 class="proceso">
            En proceso
          </h3>
          <p>La empresa ha recibido tu CV y te considerará para el proceso de selección ¡Mucha suerte!</p>
        </article>
        <article class="row-start">
          <h3 class="rechazado">
            Cerrado
          </h3>
          <p>El proceso de selección ha finalizado. La empresa ha decidido avanzar con otras candidaturas o bien la
            vacante se ha cancelado.</p>
        </article>
      </div>
    </div>


  </section>

</template>

<script lang="js">

  import practicaformalizada from '@/components/parts/practica-formalizada';
  import candidaturas from '@/components/parts/candidaturas';

  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'mis-candidaturas',
    mounted() {
      if (!!this.usertype) {
        this.getData();
      }
    },
    components: {
      practicaformalizada,
      candidaturas
    },
    data() {
      return {
        showinfo: false,
        candidaturas: '',
        documentacion: ''
      }
    },
    methods: {
      ...mapActions(['requestCandidaturas', 'requestDocumentacion']),
      getData() {
        console.log(this.usertype)
        this.requestCandidaturas(this.usertype).then(r => {
          console.log(r)
          this.candidaturas = r;
        });

        this.requestDocumentacion().then(r => {
          this.documentacion = r;
        })
      },
      eraseCandidatura(id) {
        this.candidaturas = this.candidaturas.filter(c => c.idCandidatura != id);
      }
    },
    computed: {
      ...mapGetters({
        usertype: 'getusertype'
      })
    },
    watch: {
      'usertype'() {
        this.getData();
      }
    }
  }
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/views/mis-candidaturas.vue